export default __webpack_public_path__ + "static/media/IMG_9957.59ac694c.jpg";